import { render, staticRenderFns } from "./MyNotifications.vue?vue&type=template&id=66c0ea12"
import script from "./MyNotifications.vue?vue&type=script&lang=js"
export * from "./MyNotifications.vue?vue&type=script&lang=js"
import style0 from "./MyNotifications.vue?vue&type=style&index=0&id=66c0ea12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports